import { ShieldCheck, Sparkles, Truck, Wrench, Zap } from "lucide-react";

const STORE_IMAGES = [
  { url: "https://customer-assets-jt897jd0.emergentagent.net/job_battery-finder-5/artifacts/stvtko3r_storefrontFinal1.png", alt: "Bharat Battery House storefront in Sikar — Amaron authorised outlet", span: "md:col-span-2 md:row-span-2" },
  { url: "https://customer-assets-jt897jd0.emergentagent.net/job_battery-finder-5/artifacts/p5ci45jp_storeinside1.webp", alt: "Amaron battery display inside Bharat Battery House" },
  { url: "https://customer-assets-jt897jd0.emergentagent.net/job_battery-finder-5/artifacts/35ehjc24_storeinside2.webp", alt: "Amaron battery display shelves — inside the store" },
  { url: "https://customer-assets-jt897jd0.emergentagent.net/job_battery-finder-5/artifacts/foohr7e3_storeinside3.webp", alt: "Amaron neon signage inside Bharat Battery House", span: "md:col-span-2" },
];

export default function AboutPage() {
  return (
    <div className="max-w-6xl mx-auto px-4 md:px-8 py-14 md:py-20">
      <div className="max-w-3xl">
        <div className="text-xs uppercase tracking-[0.24em] text-secondary font-bold">About</div>
        <h1 className="font-display text-4xl md:text-5xl font-black mt-2 tracking-tighter">Powering every mile in Sikar and beyond.</h1>
        <p className="mt-6 text-foreground/85 leading-relaxed">
          Bharat Battery House is a trusted battery solutions provider offering Amaron automotive batteries, two wheeler batteries,
          inverter batteries, HUPS batteries and solar power solutions. Our goal is to help customers choose the right
          battery with reliable service, quick support and genuine products.
        </p>
        <p className="mt-4 text-foreground/70 leading-relaxed">
          From daily commuter bikes to family cars, from home inverters to shop backups, and from home solar to farm power —
          our team helps you match the right capacity to the right load. We handle warranty support, doorstep delivery
          and installation guidance so you get more than just a battery — you get peace of mind.
        </p>
      </div>

      {/* Store gallery */}
      <section className="mt-14">
        <div className="text-xs uppercase tracking-[0.24em] text-secondary font-bold">Visit Our Store</div>
        <h2 className="font-display text-3xl md:text-4xl font-bold mt-2">Inside Bharat Battery House.</h2>
        <p className="mt-3 text-muted-foreground max-w-2xl">Fully-stocked Amaron authorised outlet in Sikar — batteries, HUPS units and lubricants under one roof.</p>
        <div className="mt-8 grid md:grid-cols-3 md:auto-rows-[240px] gap-4">
          {STORE_IMAGES.map((s) => (
            <div key={s.url} className={`relative overflow-hidden rounded-2xl border border-black/10 ${s.span || ""}`}>
              <img src={s.url} alt={s.alt} className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 hover:scale-105" />
            </div>
          ))}
        </div>
      </section>

      <div className="mt-14 grid sm:grid-cols-2 gap-4">
        {[
          { icon: ShieldCheck, title: "Genuine Amaron product line", text: "Original batteries with valid warranty and correct billing." },
          { icon: Sparkles, title: "Expert consultation", text: "Trained team helps you select the right fit for load & vehicle." },
          { icon: Truck, title: "Doorstep support", text: "Delivery across Sikar and nearby regions with quick turnaround." },
          { icon: Wrench, title: "Installation guidance", text: "Correct installation extends life and preserves warranty." },
        ].map(v => (
          <div key={v.title} className="border border-black/10 rounded-2xl p-5 bg-card">
            <v.icon className="h-5 w-5 text-secondary" />
            <div className="mt-3 font-display font-bold text-lg">{v.title}</div>
            <p className="text-sm text-muted-foreground mt-1">{v.text}</p>
          </div>
        ))}
      </div>

      <div className="mt-10 border-l-2 border-primary pl-5 py-1 text-foreground/80">
        <div className="text-xs uppercase tracking-[0.24em] text-secondary font-bold flex items-center gap-2"><Zap className="h-3.5 w-3.5" /> Our promise</div>
        <p className="mt-2 text-lg">Right battery. Right price. Reliable service.</p>
      </div>

      <p className="mt-10 text-xs text-muted-foreground/70">
        Note: Bharat Battery House is a battery solutions provider offering the Amaron product line — this is not the official Amaron company page.
      </p>
    </div>
  );
}
